import {
  GET_SERVICE_NUMBER_LIST_FAILURE,
  GET_SERVICE_NUMBER_LIST_REQUEST,
  GET_SERVICE_NUMBER_LIST_SUCCESS,
  GET_SERVICE_ELIGIBILITY_DETAILS_FAILURE,
  GET_SERVICE_ELIGIBILITY_DETAILS_REQUEST,
  GET_SERVICE_ELIGIBILITY_DETAILS_SUCCESS,
  GET_STAFF_PLAN_ELIGIBILITY_FAILURE,
  GET_STAFF_PLAN_ELIGIBILITY_REQUEST,
  GET_STAFF_PLAN_ELIGIBILITY_SUCCESS,
  STAFF_PLAN_RECON_ELIGIBILITY_REQUEST,
  STAFF_PLAN_RECON_ELIGIBILITY_SUCCESS,
  STAFF_PLAN_RECON_ELIGIBILITY_FAILURE
} from './actionTypes';

export const getServiceNumbers = {
  request: (page, size, searchSvcNo = '') => ({
    type: GET_SERVICE_NUMBER_LIST_REQUEST,
    page,
    size,
    searchSvcNo
  }),
  success: (data) => ({
    type: GET_SERVICE_NUMBER_LIST_SUCCESS,
    data
  }),
  failure: (error) => ({
    type: GET_SERVICE_NUMBER_LIST_FAILURE,
    error
  })
};

export const getServiceEligibilityDetails = {
  request: (serviceNoList) => ({
    type: GET_SERVICE_ELIGIBILITY_DETAILS_REQUEST,
    serviceNoList
  }),
  success: (data) => ({
    type: GET_SERVICE_ELIGIBILITY_DETAILS_SUCCESS,
    data
  }),
  failure: (error) => ({
    type: GET_SERVICE_ELIGIBILITY_DETAILS_FAILURE,
    error
  })
};

export const getStaffPlanEligibility = {
  request: (employeeId) => ({
    type: GET_STAFF_PLAN_ELIGIBILITY_REQUEST,
    employeeId
  }),
  success: (data) => ({
    type: GET_STAFF_PLAN_ELIGIBILITY_SUCCESS,
    data
  }),
  failure: (error) => ({
    type: GET_STAFF_PLAN_ELIGIBILITY_FAILURE,
    error
  })
};

export const staffPlanReconEligibility = {
  request: (serviceNoList) => ({
    type: STAFF_PLAN_RECON_ELIGIBILITY_REQUEST,
    serviceNoList
  }),
  success: (data) => ({
    type: STAFF_PLAN_RECON_ELIGIBILITY_SUCCESS,
    data
  }),
  failure: (error) => ({
    type: STAFF_PLAN_RECON_ELIGIBILITY_FAILURE,
    error
  })
};
